import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import LearningMilestoneService from "../../services/LearningMilestoneService";

import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  detailsSuccess,
  detailsFail,
  updateDetailSuccess,
  updateDetailFail,
} from "../slices/learningMilestoneSlice";

function* list(data) {
  try {
    const ajax = yield call(LearningMilestoneService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(LearningMilestoneService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(LearningMilestoneService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}
function* update(data) {
  try {
    const ajax = yield call(LearningMilestoneService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* learningMilestoneSaga() {
  yield all([
    takeLatest("learningMilestones/listRequest", list),
    takeLatest("learningMilestones/createRequest", create),
    takeLatest("learningMilestones/detailsRequest", details),
    takeLatest("learningMilestones/updateDetailRequest", update),
  ]);
}
